import { render, staticRenderFns } from "./comp_RatioBox.vue?vue&type=template&id=ab167bec&scoped=true&"
import script from "./comp_RatioBox.vue?vue&type=script&lang=js&"
export * from "./comp_RatioBox.vue?vue&type=script&lang=js&"
import style0 from "./comp_RatioBox.vue?vue&type=style&index=0&id=ab167bec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab167bec",
  null
  
)

export default component.exports